import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { useAuth } from "../auth-context/auth.context";
import { useHistory } from "react-router-dom";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Flex,
  Icon,
  useDisclosure,
  Box,
} from "@chakra-ui/react";
import { FiLock } from "react-icons/fi";

export const ProtectedRoute = ({ ...rest }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();
  const { user } = useAuth();

  useEffect(() => {
    if (!user || !user.token || user.token === "") {
      onOpen();
    }
  }, [user, onOpen]);

  if (!user || !user.token || user.token === "") {
    const handleSignIn = () => {
      onClose();
      history.push("/auth/sign-in");
    };

    return (
      <Modal isOpen={isOpen} onClose={handleSignIn} isCentered size="md" closeOnOverlayClick={false}>
        <ModalOverlay
          bg="rgba(18,40,78,0.62)"
          backdropFilter="auto"
          backdropBlur="7px"
        />
        <ModalContent
          bg="white"
          borderRadius="xl"
          boxShadow="2xl"
          px={{ base: 4, md: 8 }}
          py={6}
          border="1px solid"
          borderColor="blue.50"
        >
          <Flex direction="column" align="center" justify="center" mb={2}>
            <Box
              bg="blue.50"
              borderRadius="full"
              p={3}
              mb={3}
              boxShadow="sm"
            >
              <Icon as={FiLock} w={9} h={9} color="blue.400" />
            </Box>
            <ModalHeader
              textAlign="center"
              fontWeight="bold"
              fontSize="2xl"
              color="blue.700"
              mb={1}
              mt={2}
            >
              Restricted Access
            </ModalHeader>
            <ModalBody
              textAlign="center"
              color="blue.600"
              fontSize="md"
              px={0}
              pb={2}
            >
              <Text>
                You need to <strong>sign in</strong> to continue.
                <br />
                Please authenticate to unlock this functionality.
              </Text>
            </ModalBody>
          </Flex>
          <ModalFooter
            justifyContent="center"
            pt={3}
            pb={0}
          >
            <Button
              colorScheme="blue"
              size="lg"
              px={10}
              py={6}
              fontWeight="semibold"
              borderRadius="lg"
              fontSize="md"
              bg="blue.600"
              _hover={{ bg: "blue.700" }}
              _active={{ bg: "blue.800", transform: "scale(.97)" }}
              transition="background 0.2s, transform 0.1s"
              onClick={handleSignIn}
            >
              Sign In
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }

  return <Route {...rest} />;
};
